
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc/[topic]",
      function () {
        return require("private-next-pages/tin-tuc/[topic].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tin-tuc/[topic]"])
      });
    }
  